import React, { useEffect, useRef, useState } from 'react'
import ManageEventRevenueWrapper from '../ManageEventRevenueWrapper'
import { useParams } from 'react-router'
import ManageEventRevenueHeader from '../ManageEventRevenueHeader'
import ManageEventRevenueTabs from '../ManageEventRevenueTabs'
import { CONST } from '../../../../../const/const'
import useGetEventData from '../../../../../hooks/users/common/useGetEventData'
import ManageEventRevenueDisplayTabs from '../ManageEventRevenueDisplayTabs'
import { useDebounceWithSetter } from '../../../../../hooks/useDebounceWithSetter'
const RegistrationRevenue = () => {
  const { getAllData } = useGetEventData()
  const { eventId } = useParams<{ eventId: string }>()

  const inputRef = useRef<HTMLInputElement>(null)

  const { debounceSetter } = useDebounceWithSetter({
    delay: 300,
    value: '',
  })
  const [eventTab, setEventTab] = useState(CONST.UI.EVENTS.REVENUE.TABS.ALL.VALUE)

  useEffect(() => {
    if (eventId) {
      getAllData(eventId, [
        'v01_event_fees',
        'v01_event_details',
        'v01_event_payments_settings',
        'v01_event_registered_users',
        'v01_event_ticketing',
      ])
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [eventId])

  const onSearchValueChange = (updatedValue: string) => {
    debounceSetter(updatedValue)
  }

  return (
    <ManageEventRevenueWrapper eventId={eventId}>
      <>
        <div className="w-full flex mb-4 flex-wrap">
          <ManageEventRevenueHeader
            revenueType={'Registration'}
            imgUrl={'/assets/cp_icons/UserGroups-3.svg'}
          />
          <ManageEventRevenueTabs
            ref={inputRef}
            eventTab={eventTab}
            setEventTab={setEventTab}
            setSearchValue={onSearchValueChange}
          />
          <ManageEventRevenueDisplayTabs
            eventId={eventId}
            eventTab={eventTab}
            searchValue={inputRef.current?.value ?? ''}
          />
        </div>
      </>
    </ManageEventRevenueWrapper>
  )
}

export default RegistrationRevenue
